import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Components from "@signify/vue-components";
import settings from "@/service/Settings";
import * as Sentry from "@sentry/browser";
import * as SentryIntegrations from "@sentry/integrations";
import modalRouter from "./modal";
import Snotify, { SnotifyPosition } from "vue-snotify";
import canI from "@/mixins/can-i";
import VueResize from "vue-resize";
import VueCookies from "vue-cookies";
import Multiselect from "vue-multiselect";

if (settings.SENTRY_DSN) {
  Sentry.init({
    dsn: settings.SENTRY_DSN,
    environment: settings.SENTRY_ENVIRONMENT || 'unknown',
    release: settings.SENTRY_RELEASE || 'master',
    integrations: [
      new SentryIntegrations.Vue({
        Vue,
        attachProps: true,
        logErrors: false
      })
    ],
    beforeSend(event) {
      // Filter out browser extension errors
      if (event.exception && event.exception.values) {
        const exceptionValue = event.exception.values[0];
        const message = (exceptionValue && exceptionValue.value) ? exceptionValue.value : '';

        if (message.includes('chrome-extension://') ||
            message.includes('moz-extension://') ||
            message.includes('ResizeObserver')) {
          return null;
        }
      }
      return event;
    }
  });

  // Set tags
  Sentry.setTag('module', 'frontend-vue');
}

const snotifyOptions = {
  toast: {
    position: SnotifyPosition.rightTop,
    showProgressBar: false,
    titleMaxLength: 150,
    timeout: 4000,
    animation: { enter: "fadeIn", exit: "fadeOut", time: 200 }
  }
};

Vue.component("multiselect", Multiselect);
Vue.use(VueResize);
Vue.use(VueCookies);
Vue.use(Snotify, snotifyOptions);
Vue.use(Components);
Vue.mixin(canI);

Vue.directive("focus", {
  inserted: function(el) {
    el.focus();
  }
});

Vue.config.productionTip = true;
Vue.config.performance = true;

Vue.prototype.$imageBase = "https://www.api.easydesignintool.signify.com";

new Vue({
  router,
  modalRouter,
  store,
  render: h => h(App)
}).$mount("#app");
